import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import GmailComposeModal from "../GmailComposeModal";
import useInbox from "../InboxContext";
import LabelDropdown from "./LabelDropdown";
import SwitchEmail from "./SwitchEmail";

function buildLabelTree(labels) {
  const tree = {};
  labels.forEach((label) => {
    const parts = label.name.split("/");
    let current = tree;
    parts.forEach((part, idx) => {
      if (!current[part]) {
        current[part] = {
          __children: {},
          __label: idx === parts.length - 1 ? label : null,
        };
      }
      current = current[part].__children;
    });
  });
  return tree;
}

export default function LabelsList() {
  const {
    labels,
    loading,
    refreshLabels,
    selectedLabel,
    setSelectedLabel,
    setPageTokensList,
    defaultLabels,
    setRefreshEmails,
    selectedGrantEmail,
    setMessageId,
  } = useInbox();

  /*   All States ********************************* */
  const user = useSelector((state) => state.user.userInfo);

  const [showComposeModal, setShowComposeModal] = useState(false);

  /*   All Functions
   ********************************************* */

  const ComposeBtn = ({ onClickFunc, disableConditions }) => {
    return (
      <button
        disabled={disableConditions}
        className="btn border-primary bg-primary bg-opacity-10 flex-center gap-2 px-3 py-2 custom-border-radius fw-bold"
        onClick={onClickFunc}
      >
        <i className="mdi mdi-pencil fw-bold fs-4"></i> Compose
      </button>
    );
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      refreshLabels();
    }, 50);
    return () => clearTimeout(timeout);
  }, [refreshLabels]);

  return (
    <div style={{ position: "relative" }} className="d-flex flex-column h-100 ">
      {loading && <Spinner />}

      {/* ******************** Switch Email ************************* */}
      <div className="px-3 py-2">
        <SwitchEmail />
      </div>
      <hr className="my-1" />

      {/* ******************** Compose Email ************************* */}
      <div className="px-3 d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-1 w-100 my-1">
          {/* <ComposeModal
            ComposeBtn={ComposeBtn}
            show={showComposeModal}
            setShow={setShowComposeModal}
          /> */}
          <ComposeBtn
            onClickFunc={() => setShowComposeModal(true)}
            disableConditions={loading}
          />
          <GmailComposeModal
            show={showComposeModal}
            setShow={setShowComposeModal}
            closeFunc={(e) => {
              // refreshLabels();
              setRefreshEmails(true);
            }}
          />
        </div>
      </div>

      {/* ******************** Labels List ************************* */}
      <nav className="overflow-auto mt-2">
        {(user.roles === "admin" || user.permissions.includes("show_inbox")) &&
          defaultLabels.map((label) => (
            <div key={label.labelId} className="">
              <ul className="list-unstyled mb-0">
                <li
                  className={`${
                    selectedLabel === label.labelId
                      ? "fw-bold fs-5 px-3 py-1 active-inbox-item"
                      : "fw-bold fs-5 px-3 py-1"
                  }`}
                  type="button"
                  onClick={(e) => {
                    setMessageId(null);
                    setMessageId(null);
                    setPageTokensList([]);
                    setSelectedLabel(label.labelId);
                  }}
                >
                  <i
                    className={`mdi mdi-${
                      label.labelId === "INBOX"
                        ? "inbox"
                        : label.labelId === "SENT"
                        ? "send"
                        : label.labelId === "TRASH"
                        ? "trash-can"
                        : label.labelId === "ALL_MAILS"
                        ? "email-multiple-outline"
                        : "label"
                    } me-2`}
                  ></i>
                  {label.name}
                  {label?.unreadCount > 0 && (
                    <span className="badge bg-danger ms-2">
                      {label?.unreadCount}
                    </span>
                  )}
                </li>
              </ul>
            </div>
          ))}

        {/* Labels */}

        <hr className="mt-1" />
        <div className="px-3 d-flex align-items-center justify-content-between mb-1">
          <h4
            style={{
              fontWeight: "bolder",
            }}
          >
            TEAMS
          </h4>
          <div className="d-flex align-items-center">
            <button
              disabled={loading}
              className="px-1 py-0 btn btn-sm btn-outline-secondary"
              onClick={() => refreshLabels(true)}
              title="Create Label"
            >
              <i className="mdi mdi-refresh"></i>
            </button>
          </div>
        </div>

        <ul className="list-unstyled mb-0">
          {Object.entries(buildLabelTree(labels)).map(([name, node]) => {
            if (name === "archived_mails") {
              return null;
            }
            return (
              <LabelDropdown
                key={name}
                name={name}
                node={node}
                selectedLabel={selectedLabel}
                setSelectedLabel={setSelectedLabel}
              />
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
